<template>
	<div>
		<div>
			<el-dialog title="添加终端" :visible.sync="dialogAddVisible" :width="$store.state.width>$store.state.minwidth?'800px':($store.state.width-12+'px')"
			 label-position="right" :before-close="formClose" center>
				<div v-loading="$store.state.formload">
					<el-form :label-width="$store.state.width>$store.state.minwidth?'110px':''" class="demo-form-inline">
						<el-form-item class="kuan" label="类 型" prop="type" :rules="{ required: true, message: '请选择类型', trigger: 'blur' }">
							<el-select v-model="type" placeholder="请选择" class="kuan">
								<el-option label="终端" :value="1"></el-option>
								<el-option label="RFID" :value="2"></el-option>
							</el-select>
						</el-form-item>
					</el-form>
					<el-form v-if="type==1" :model="formAdd" ref="formAdd" :label-width="$store.state.width>$store.state.minwidth?'110px':''"
					 class="demo-form-inline">
						<el-form-item class="kuan" label="标 识 符" prop="tag" :rules="{ required: true, message: '标识符不能为空', trigger: 'blur' }">
							<el-input class="kuan" v-model="formAdd.tag"></el-input>
						</el-form-item>
						<el-form-item class="kuan" label="终端名称" prop="name" :rules="[{ required: true, message: '终端名称不能为空', trigger: 'blur' },{ max: 15, message: '最多支持 15 个字符'}]">
							<el-input class="kuan" v-model="formAdd.name"></el-input>
						</el-form-item>
						<el-form-item class="kuan" label="地理位置" prop="address">
							<el-cascader :options="$store.state.address" v-model="formAdd.address" change-on-select :props="props" class="kuan">
							</el-cascader>
						</el-form-item>
						<el-form-item class="kuan" label="终端图片" prop="image" :rules="{ required: true, message: '终端图片不能为空', trigger: 'blur' }">
							<el-upload class="avatar-uploader" :action="config['apiurl'] + '/api/common/upload'" :show-file-list="false"
							 :on-success="AddhandleAvatarSuccess" :before-upload="AddbeforeAvatarUpload" align="left">
								<img v-if="formAdd.image" :src="config.apiurl+formAdd.image" class="avatar border">
								<i v-else class="el-icon-plus avatar-uploader-icon border"></i>
							</el-upload>
						</el-form-item>
					</el-form>
					<el-form v-else-if="type==2" :model="AddRFID" ref="AddRFID" :label-width="$store.state.width>$store.state.minwidth?'110px':''"
					 class="demo-form-inline">
						<el-form-item class="kuan" label="设 备 号" prop="devicesNo" :rules="{ required: true, message: '设备号不能为空', trigger: 'blur' }">
							<el-input class="kuan" v-model="AddRFID.devicesNo"></el-input>
						</el-form-item>
						<el-form-item class="kuan" label="名 称" prop="name" :rules="[{ required: true, message: '名称不能为空', trigger: 'blur' },{ max: 15, message: '最多支持 15 个字符'}]">
							<el-input class="kuan" v-model="AddRFID.name"></el-input>
						</el-form-item>
						<el-form-item class="kuan" label="终端图片" prop="image" :rules="{ required: true, message: '请上传图片', trigger: 'blur' }">
							<my-upload v-model="AddRFID.image"></my-upload>
						</el-form-item>
						<el-form-item class="kuan" label="地理位置" prop="address" :rules="{ required: true, message: '请选择地址', trigger: 'blur' }">
							<my-cascader v-model="AddRFID.address"></my-cascader>
						</el-form-item>
						<el-form-item class="kuan" label="描 述" prop="description">
							<el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="AddRFID.description">
							</el-input>
						</el-form-item>
					</el-form>
					<div slot="footer" class="dialog-footer">
						<el-button type="primary" @click="SaveTerminal()">确 定</el-button>
						<el-button @click="dialogAddVisible = false">取 消</el-button>
					</div>
				</div>
			</el-dialog>
			<el-dialog title="编辑终端" :visible.sync="dialogEditVisible" :width="$store.state.width>$store.state.minwidth?'800px':($store.state.width-12+'px')"
			 label-position="right" :before-close="formClose" center>
				<div v-loading="$store.state.formload">
					<el-form :label-width="$store.state.width>$store.state.minwidth?'110px':''" class="demo-form-inline">
						<el-form-item class="kuan" label="类 型" prop="type" :rules="{ required: true, message: '请选择类型', trigger: 'blur' }">
							<el-select v-model="type" placeholder="请选择" class="kuan" disabled>
								<el-option label="终端" :value="1"></el-option>
								<el-option label="RFID" :value="2"></el-option>
							</el-select>
						</el-form-item>
					</el-form>
					<el-form v-if="type==1" :model="formEdit" ref="formEdit" :label-width="$store.state.width>$store.state.minwidth?'110px':''">
						<el-form-item label="标 识 符" prop="tag" :rules="{ required: true, message: '标识符不能为空', trigger: 'blur' }">
							<el-input v-model="formEdit.tag" :disabled="true"></el-input>
						</el-form-item>
						<el-form-item label="终端名称" prop="name" :rules="[{ required: true, message: '终端名称不能为空', trigger: 'blur' },{ max: 15, message: '最多支持 15 个字符'}]">
							<el-input v-model="formEdit.name"></el-input>
						</el-form-item>
						<el-form-item class="kuan" label="终端图片" prop="image" :rules="{ required: true, message: '终端图片不能为空', trigger: 'blur' }">
							<el-upload class="avatar-uploader" :action="config['apiurl'] + '/api/common/upload'" :show-file-list="false"
							 :on-success="EdithandleAvatarSuccess" :before-upload="EditbeforeAvatarUpload" align="left">
								<img v-if="formEdit.image" :src="config.apiurl+formEdit.image" class="avatar border">
								<i v-else class="el-icon-plus avatar-uploader-icon border"></i>
							</el-upload>
						</el-form-item>
						<el-form-item class="kuan" label="地理位置" prop="address">
							<el-cascader placeholder="(未修改)" :options="$store.state.address" v-model="formEdit.address" change-on-select
							 :props="props" class="kuan">
							</el-cascader>
						</el-form-item>
					</el-form>
					<el-form v-else-if="type==2" :model="EditRFID" ref="EditRFID" :label-width="$store.state.width>$store.state.minwidth?'110px':''"
					 class="demo-form-inline">
						<el-form-item class="kuan" label="设 备 号" prop="devicesNo" :rules="{ required: true, message: '设备号不能为空', trigger: 'blur' }">
							<el-input class="kuan" v-model="EditRFID.devicesNo" disabled></el-input>
						</el-form-item>
						<el-form-item class="kuan" label="名 称" prop="name" :rules="[{ required: true, message: '名称不能为空', trigger: 'blur' },{ max: 15, message: '最多支持 15 个字符'}]">
							<el-input class="kuan" v-model="EditRFID.name"></el-input>
						</el-form-item>
						<el-form-item class="kuan" label="终端图片" prop="image" :rules="{ required: true, message: '请上传图片', trigger: 'blur' }">
							<my-upload v-model="EditRFID.image"></my-upload>
						</el-form-item>
						<el-form-item class="kuan" label="地理位置" prop="address" :rules="{ required: true, message: '请选择地址', trigger: 'blur' }">
							<my-cascader v-model="EditRFID.address" placeholder="(未修改)"></my-cascader>
						</el-form-item>
						<el-form-item class="kuan" label="描 述" prop="description">
							<el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="EditRFID.description">
							</el-input>
						</el-form-item>
					</el-form>
					<div slot="footer" class="dialog-footer">
						<el-button type="primary" @click="EditTerminal()">确 定</el-button>
						<el-button @click="dialogEditVisible = false">取 消</el-button>
					</div>
				</div>
			</el-dialog>
			<el-dialog class="info" :title="Info.name" :visible.sync="dialogInfo" :width="$store.state.width>$store.state.minwidth?'600px':($store.state.width-12+'px')"
			 label-position="right" center>
				<el-row>
					<el-col :span="24" v-if="Info.serial">
						<el-col :span="8" class="info-title">序列号：</el-col>
						<el-col :span="16" class="info-content">{{Info.serial}}</el-col>
					</el-col>
					<el-col :span="24" v-if="Info.IMEI">
						<el-col :span="8" class="info-title">IMEI：</el-col>
						<el-col :span="16" class="info-content">{{Info.IMEI}}</el-col>
					</el-col>
					<el-col :span="24" v-if="Info.CCID">
						<el-col :span="8" class="info-title">CCID：</el-col>
						<el-col :span="16" class="info-content">{{Info.CCID}}</el-col>
					</el-col>
					<el-col :span="24" v-if="Info.sw_version">
						<el-col :span="8" class="info-title">软件版本：</el-col>
						<el-col :span="16" class="info-content">{{Info.sw_version}}</el-col>
					</el-col>
					<el-col :span="24" v-if="Info.hw_version">
						<el-col :span="8" class="info-title">硬件版本：</el-col>
						<el-col :span="16" class="info-content">{{Info.hw_version}}</el-col>
					</el-col>
				</el-row>
				<div slot="footer" class="dialog-footer">
					<el-button type="primary" @click="dialogInfo=false">我知道了</el-button>
				</div>
			</el-dialog>
			<el-dialog :title="icoName" :visible.sync="dialogIco" :width="$store.state.width>$store.state.minwidth?'350px':($store.state.width-12+'px')"
			 label-position="right" center>
				<canvas id="ico"></canvas>
				<div class="ico-downLoad">
					<span @click="saveIco()">下载二维码</span>
				</div>
			</el-dialog>
			<el-dialog title="终端配置管理" :visible.sync="dialogDevice" :width="$store.state.width>$store.state.minwidth?'800px':($store.state.width-12+'px')"
			 label-position="right" center>
				<el-tabs type="card" v-model="deviceType" @tab-click="handleDevice">
					<el-tab-pane label="氧限设置" name="do_limit">
						<el-collapse v-model="NOs">
							<el-collapse-item v-for="(items,index) in do_limit" :name="index" :key="index">
								<div slot="title" class="config-device-box">
									<div class="config-device-box-title">通道号：{{Number(index.split(',')[1])+1}}号<span v-if="$store.state.width>$store.state.minwidth">&nbsp;&nbsp;通道编码：{{index.split(',')[0]}}</span></div>
									<div class="config-device-box-set" @click.stop="OpenConfig(index)">去设置</div>
								</div>
								<el-tag class="config-device-box-name" type="success" v-for="item in items" :key="item.id">{{item.alias}}</el-tag>
							</el-collapse-item>
						</el-collapse>
					</el-tab-pane>
					<el-tab-pane label="传感器清洗设置" name="rinse_set">
						<el-collapse v-model="NOs">
							<el-collapse-item v-for="(items,index) in rinse_set" :name="index" :key="index">
								<div slot="title" class="config-device-box">
									<div class="config-device-box-title">通道号：{{Number(index.split(',')[1])+1}}号<span v-if="$store.state.width>$store.state.minwidth">&nbsp;&nbsp;通道编码：{{index.split(',')[0]}}</span></div>
									<div class="config-device-box-set" @click.stop="OpenConfig(index)">去设置</div>
								</div>
								<el-tag class="config-device-box-name" v-for="item in items" :key="item.id">{{item.alias}}</el-tag>
							</el-collapse-item>
						</el-collapse>
					</el-tab-pane>
					<el-tab-pane label="定时控制" name="time_ctl">
						<el-collapse v-model="NOs">
							<el-collapse-item v-for="(items,index) in time_ctl" :name="index" :key="index">
								<div slot="title" class="config-device-box">
									<div class="config-device-box-title">通道号：{{Number(index.split(',')[1])+1}}号<span v-if="$store.state.width>$store.state.minwidth">&nbsp;&nbsp;通道编码：{{index.split(',')[0]}}</span></div>
									<div class="config-device-box-set" @click.stop="OpenConfig(index)">去设置</div>
								</div>
								<el-tag type="info" class="config-device-box-name" v-for="item in items" :key="item.id">{{item.alias}}</el-tag>
							</el-collapse-item>
						</el-collapse>
					</el-tab-pane>
				</el-tabs>
			</el-dialog>
			<el-dialog title="终端配置管理" :visible.sync="dialogConfig" :width="$store.state.width>$store.state.minwidth?'600px':($store.state.width-12+'px')"
			 label-position="right" center>
				<template v-if="this.deviceType=='do_limit'">
					<div class="config-title">氧限设置</div>
					<el-form :model="LimitConfig" ref="LimitConfig" :label-width="$store.state.width>$store.state.minwidth?'80px':''"
					 class="demo-form-inline" :rules="rules">
						<el-form-item class="kuan" label="高 限" prop="high_limit">
							<el-input class="kuan" v-model="LimitConfig.high_limit">
								<template slot="append">mg/L</template>
							</el-input>
						</el-form-item>
						<el-form-item class="kuan" label="上 限" prop="up_limit">
							<el-input class="kuan" v-model="LimitConfig.up_limit">
								<template slot="append">mg/L</template>
							</el-input>
						</el-form-item>
						<el-form-item class="kuan" label="下 限" prop="down_limit">
							<el-input class="kuan" v-model="LimitConfig.down_limit">
								<template slot="append">mg/L</template>
							</el-input>
						</el-form-item>
					</el-form>
				</template>
				<template v-if="this.deviceType=='time_ctl'">
					<div class="config-title">定时控制</div>
					<el-form :model="TimeConfig" ref="TimeConfig" :label-width="$store.state.width>$store.state.minwidth?'80px':''"
					 class="demo-form-inline" :rules="rules">
						<el-form-item class="kuan" label="开启时间" prop="on_time">
							<el-input class="kuan" v-model="TimeConfig.on_time">
								<template slot="append">分钟</template>
							</el-input>
						</el-form-item>
						<el-form-item class="kuan" label="关闭时间" prop="off_time">
							<el-input class="kuan" v-model="TimeConfig.off_time">
								<template slot="append">分钟</template>
							</el-input>
						</el-form-item>
					</el-form>
				</template>
				<template v-if="this.deviceType=='rinse_set'">
					<div class="config-title">传感器清洗设置</div>
					<el-form :model="RinseConfig" ref="RinseConfig" :label-width="$store.state.width>$store.state.minwidth?'80px':''"
					 class="demo-form-inline" :rules="rules">
						<el-form-item class="kuan" label="清洗周期" prop="rinse_period">
							<el-input class="kuan" v-model="RinseConfig.rinse_period">
								<template slot="append">分钟</template>
							</el-input>
						</el-form-item>
					</el-form>
				</template>
				<div class="dialog-footer">
					<el-button type="primary" @click="SaveConfig()">保 存</el-button>
					<el-button @click="dialogConfig = false">取 消</el-button>
				</div>
			</el-dialog>
		</div>
		<div>
			<el-row>
				<el-col :span="24">
					<div class="bread">
						<el-breadcrumb separator-class="el-icon-arrow-right">
							<el-breadcrumb-item v-if="$store.state.main.user.m_qaedas_id==0" :to="{ path: '/main' }">基地管理</el-breadcrumb-item>
							<el-breadcrumb-item>终端管理</el-breadcrumb-item>
						</el-breadcrumb>
					</div>
				</el-col>
			</el-row>
			<el-row class="top">
				<el-col :span="24">
					<el-button type="primary" :size="$store.state.width<$store.state.minwidth?'small':''" icon="el-icon-circle-plus-outline"
					 @click="AddOpenTerminal()">添加终端</el-button>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="24">
					<el-tabs v-model="activeName">
						<el-tab-pane label="终端信息" name="first">
							<el-row v-if="$store.state.Iot.terminal.length>0" class="card-w">
								<el-col :span="24">
									<el-card shadow="hover" :body-style="{ padding: '0px' }" class="bg-purple" v-for="(item, key) in $store.state.Iot.terminal"
									 v-if="item.agoTerminal==1" :key="key">
										<div>
											<div class="card2">
												<div class="card3">
													<div class="zi1" :title="item.name">{{item.name}}&nbsp;</div>
													<i class="el-icon-info" style="cursor: pointer; line-height: 23px; float: left;" @click="openInfo(item)"></i>
													<el-button class="zi2" icon="el-icon-edit" type="text" @click="EditOpenTerminal(item)"></el-button>
													<span v-if="item.state=='0'" class="lixian" type="text"><i class="el-icon-success"></i> 禁用</span>
													<span v-else-if="item.state=='1'" class="zaixian" type="text"><i class="el-icon-success"></i> 在线</span>
													<span v-else-if="item.state=='2'" class="lixian" type="text"><i class="el-icon-question"></i> 未使用</span>
													<span v-else-if="item.state=='3'" class="lixian" type="text"><i class="el-icon-error"></i> 离线</span>
													<span v-else class="lixian" type="text"><i class="el-icon-warning"></i> 异常</span>
												</div>
											</div>
											<div @click="moveto(item)" style="cursor: pointer;">
												<el-row class="ljs-body">
													<el-col :span="10" class="ljs-beijing">
														<img :src="config['apiurl'] + item.image">
													</el-col>
													<div v-if="item.isDisinfection==1">
														<el-col :span="9" :offset="1" class="dis-inbl">
															<p>{{item.disinfectionCount.countDisinfectionAlarmLogName}}：</p>
															<p>{{item.disinfectionCount.countDisinfectionLogName}}：</p>
															<p>{{item.disinfectionCount.countDisinfectionPowerLogName}}：</p>
														</el-col>
														<el-col :span="4" class="tex-ri">
															<p class="ljs-zi2" :title="item.disinfectionCount.countDisinfectionAlarmLog">{{ convert(item.disinfectionCount.countDisinfectionAlarmLog) }}</p>
															<p class="ljs-zi2" :title="item.disinfectionCount.countDisinfectionLog">{{ convert(item.disinfectionCount.countDisinfectionLog) }}</p>
															<p class="ljs-zi2" :title="item.disinfectionCount.countDisinfectionPowerLog">{{ convert(item.disinfectionCount.countDisinfectionPowerLog) }}</p>
														</el-col>
													</div>
													<div v-else-if="item.isSample==1">
														<el-col :span="9" :offset="1" class="dis-inbl">
															<p>{{item.sampleCount.countSampleName}}：</p>
															<p>{{item.sampleCount.countSampleAlarmLogName}}：</p>
															<p>{{item.sampleCount.countSampleLogName}}：</p>
														</el-col>
														<el-col :span="4" class="tex-ri">
															<p class="ljs-zi2" :title="item.sampleCount.countSample">{{ convert(item.sampleCount.countSample) }}</p>
															<p class="ljs-zi2" :title="item.sampleCount.countSampleAlarmLog">{{ convert(item.sampleCount.countSampleAlarmLog) }}</p>
															<p class="ljs-zi2" :title="item.sampleCount.countSampleLog">{{ convert(item.sampleCount.countSampleLog) }}</p>
														</el-col>
													</div>
													<div v-else>
														<el-col :span="9" :offset="1" class="dis-inbl">
															<p>传感器数：</p>
															<p>控制器数：</p>
															<p>数据条数：</p>
														</el-col>
														<el-col :span="4" class="tex-ri">
															<p class="ljs-zi2" :title="item.devicesCount.countSensor">{{ item.devicesCount.countSensor }}</p>
															<p class="ljs-zi2" :title="item.devicesCount.countFinal">{{ item.devicesCount.countFinal }}</p>
															<p class="ljs-zi2" :title="item.devicesCount.countDevicesData">{{ convert(item.devicesCount.countDevicesData) }}</p>
														</el-col>
													</div>
													<el-col :span="24">
														<div class="bottom-address">
															<div v-if="item.isConfig==2" class="address-config" @click.stop="OpenDevice(item)">
																<i class="el-icon-setting"></i>
															</div>
															<div class="address-text" :title="item.address">{{item.address}}</div>
															<div class="address-ico" @click.stop="OpenIco(item)">
																<i class="my-icon-ico"></i>
															</div>
														</div>
														<!-- <p class="ljs-diqu" :title="item.address">{{item.address}}</p> -->
													</el-col>
												</el-row>
											</div>
										</div>
									</el-card>
								</el-col>
							</el-row>
							<el-row v-else>
								<el-col :span="24">
									<div class="none">
										<span>暂无数据 ！</span>
									</div>
								</el-col>
							</el-row>
							<el-divider v-if="isHistory" content-position="left">历史终端</el-divider>
							<el-row v-if="isHistory" class="card-w">
								<el-col :span="24">
									<el-card shadow="hover" :body-style="{ padding: '0px' }" class="bg-purple" v-for="(item, key) in $store.state.Iot.terminal"
									 v-if="item.agoTerminal==2" :key="key">
										<div>
											<div class="card2">
												<div class="card3">
													<div class="zi1" :title="item.name">{{item.name}}&nbsp;</div>
													<i class="el-icon-info" style="cursor: pointer; line-height: 23px; float: left;" @click="openInfo(item)"></i>
													<el-button class="zi2" icon="el-icon-edit" type="text" @click="EditOpenTerminal(item)"></el-button>
													<span v-if="item.state=='0'" class="lixian" type="text"><i class="el-icon-success"></i> 禁用</span>
													<span v-else-if="item.state=='1'" class="zaixian" type="text"><i class="el-icon-success"></i> 在线</span>
													<span v-else-if="item.state=='2'" class="lixian" type="text"><i class="el-icon-question"></i> 未使用</span>
													<span v-else-if="item.state=='3'" class="lixian" type="text"><i class="el-icon-error"></i> 离线</span>
													<span v-else class="lixian" type="text"><i class="el-icon-warning"></i> 异常</span>
												</div>
											</div>
											<div @click="moveto(item)" style="cursor: pointer;">
												<el-row class="ljs-body">
													<el-col :span="10" class="ljs-beijing">
														<img :src="config['apiurl'] + item.image">
													</el-col>
													<div v-if="item.isDisinfection==1">
														<el-col :span="9" :offset="1" class="dis-inbl">
															<p>{{item.disinfectionCount.countDisinfectionAlarmLogName}}：</p>
															<p>{{item.disinfectionCount.countDisinfectionLogName}}：</p>
															<p>{{item.disinfectionCount.countDisinfectionPowerLogName}}：</p>
														</el-col>
														<el-col :span="4" class="tex-ri">
															<p class="ljs-zi2" :title="item.disinfectionCount.countDisinfectionAlarmLog">{{ convert(item.disinfectionCount.countDisinfectionAlarmLog) }}</p>
															<p class="ljs-zi2" :title="item.disinfectionCount.countDisinfectionLog">{{ convert(item.disinfectionCount.countDisinfectionLog) }}</p>
															<p class="ljs-zi2" :title="item.disinfectionCount.countDisinfectionPowerLog">{{ convert(item.disinfectionCount.countDisinfectionPowerLog) }}</p>
														</el-col>
													</div>
													<div v-else-if="item.isSample==1">
														<el-col :span="9" :offset="1" class="dis-inbl">
															<p>{{item.sampleCount.countSampleName}}：</p>
															<p>{{item.sampleCount.countSampleAlarmLogName}}：</p>
															<p>{{item.sampleCount.countSampleLogName}}：</p>
														</el-col>
														<el-col :span="4" class="tex-ri">
															<p class="ljs-zi2" :title="item.sampleCount.countSample">{{ convert(item.sampleCount.countSample) }}</p>
															<p class="ljs-zi2" :title="item.sampleCount.countSampleAlarmLog">{{ convert(item.sampleCount.countSampleAlarmLog) }}</p>
															<p class="ljs-zi2" :title="item.sampleCount.countSampleLog">{{ convert(item.sampleCount.countSampleLog) }}</p>
														</el-col>
													</div>
													<div v-else>
														<el-col :span="9" :offset="1" class="dis-inbl">
															<p>传感器数：</p>
															<p>控制器数：</p>
															<p>数据条数：</p>
														</el-col>
														<el-col :span="4" class="tex-ri">
															<p class="ljs-zi2" :title="item.devicesCount.countSensor">{{ item.devicesCount.countSensor }}</p>
															<p class="ljs-zi2" :title="item.devicesCount.countFinal">{{ item.devicesCount.countFinal }}</p>
															<p class="ljs-zi2" :title="item.devicesCount.countDevicesData">{{ convert(item.devicesCount.countDevicesData) }}</p>
														</el-col>
													</div>
													<el-col :span="24">
														<div class="bottom-address">
															<div class="address-text" :title="item.address">{{item.address}}</div>
															<div class="address-ico" @click.stop="OpenIco(item)">
																<i class="my-icon-ico"></i>
															</div>
														</div>
														<!-- <p class="ljs-diqu" :title="item.address">{{item.address}}</p> -->
													</el-col>
												</el-row>
											</div>
										</div>
									</el-card>
								</el-col>
							</el-row>
						</el-tab-pane>
						<el-tab-pane v-if="RFIDData.length>0" label="RFID信息" name="second">
							<el-row v-if="RFIDData.length>0" class="card-w">
								<el-col :span="24">
									<el-card shadow="hover" :body-style="{ padding: '0px' }" class="bg-purple" v-for="(item, key) in RFIDData"
									 :key="key">
										<div>
											<div class="card2">
												<div class="card3">
													<span class="zi1">{{item.name}}</span>
													<el-popover placement="bottom" width="60" trigger="hover">
														<div>
															<el-button type="primary" size="mini" @click="EditOpenTerminal(item)" class="sm-btn1">编辑</el-button>
															<el-button style="float: right;" type="danger" size="mini" @click="clearData(item)">清除</el-button>
														</div>
														<el-button slot="reference" class="zi2" icon="el-icon-edit" type="text"></el-button>
													</el-popover>
													<span v-if="item.terminalStatus=='1'" class="zaixian" type="text"><i class="el-icon-success"></i> 在线</span>
													<span v-else-if="item.terminalStatus=='2'" class="lixian" type="text"><i class="el-icon-error"></i> 离线</span>
													<span v-else class="lixian" type="text"><i class="el-icon-warning"></i> 异常</span>
												</div>
											</div>
											<div @click="moveto(item)" style="cursor: pointer;">
												<el-row class="ljs-body">
													<el-col :span="10" class="ljs-beijing">
														<img :src="config['apiurl'] + item.image">
													</el-col>
													<el-col :span="9" :offset="1" class="dis-inbl">
														<p>标签总数：</p>
														<p>天线总数：</p>
														<p>读取总数：</p>
													</el-col>
													<el-col :span="4" class="tex-ri">
														<p class="ljs-zi2" :title="item.epcCount">{{ item.epcCount }}</p>
														<p class="ljs-zi2" :title="item.antennaCount">{{ item.antennaCount }}</p>
														<p class="ljs-zi2" :title="item.labelCount">{{ convert(item.labelCount) }}</p>
													</el-col>
													<el-col :span="24">
														<p class="ljs-diqu" :title="item.address">{{item.address}}</p>
													</el-col>
												</el-row>
											</div>
										</div>
									</el-card>
								</el-col>
							</el-row>
							<el-row v-else>
								<el-col :span="24">
									<div class="none">
										<span>暂无数据 ！</span>
									</div>
								</el-col>
							</el-row>
						</el-tab-pane>
						<el-tab-pane label="设备策略" name="third" v-if="$store.state.main.qaedas.doTactics_system==1">
							<crud :fields="fields" :select="[]" :limits="limits" apiU="Tactics"></crud>
						</el-tab-pane>
					</el-tabs>
				</el-col>
			</el-row>
		</div>
	</div>
</template>

<script>
	let _this;
	import qrious from 'qrious';
	export default {
		data() {
			let min = (rule, value, callback) => {
				if (Number(value) < 0) {
					return callback(new Error('请输入不小于的0的值'));
				} else {
					callback();
				}
			};
			let checkNum = (rule, value, callback) => {
				if (Number(value) == 0) {
					return callback();
				} else if (!Number(value)) {
					return callback(new Error('请输入数值'));
				} else {
					callback();
				}
			};
			let checkHight = (rule, value, callback) => {
				if ((Number(value) - Number(this.LimitConfig.up_limit)).toFixed(1) < 0.2) {
					return callback(new Error('高限应大于上限 0.2 及以上'));
				} else {
					callback();
				}
			};
			let checkUp = (rule, value, callback) => {
				if ((Number(value) - Number(this.LimitConfig.down_limit)).toFixed(1) < 0.2) {
					return callback(new Error('上限应大于下限 0.2 及以上'));
				} else if ((Number(this.LimitConfig.high_limit) - Number(value)).toFixed(1) < 0.2) {
					return callback(new Error('上限应小于高限 0.2 及以上'));
				} else {
					callback();
				}
			};
			let checkDown = (rule, value, callback) => {
				if ((Number(this.LimitConfig.up_limit) - Number(value)).toFixed(1) < 0.2) {
					return callback(new Error('下限应小于上限 0.2 及以上'));
				} else {
					callback();
				}
			};
			let checkRinse = (rule, value, callback) => {
				if (Number(value) > 6000 || Number(value) < 6) {
					return callback(new Error('时间范围为：6 - 6000 '));
				} else {
					callback();
				}
			};
			let checkOnOff = (rule, value, callback) => {
				if (Number(value) > 999 || Number(value) < 1) {
					return callback(new Error('数值范围为：1 - 999 '));
				} else {
					callback();
				}
			};
			return {
				mytime: null,
				activeName: "first",
				RFIDData: [],
				type: 1,
				AddRFID: {
					qaedaId: "",
					name: "",
					devicesNo: "",
					image: "",
					address: "",
					description: ""
				},
				EditRFID: {
					id: "",
					name: "",
					image: "",
					address: "",
					devicesNo: "",
					description: ""
				},
				myload: true,
				formload: false,
				Terminal: [],
				dialogAddVisible: false,
				formAdd: {
					name: '',
					tag: '',
					address: [],
					image: '',
				},
				dialogEditVisible: false,
				formEdit: {
					id: '',
					name: '',
					tag: '',
					address: [],
					image: '',
				},
				dialogInfo: false,
				Info: {
					name: "设备信息"
				},
				dialogIco: false,
				icoName: "设备信息",
				terminalData: {},
				deviceType: "do_limit",
				NOs: [],
				dialogDevice: false,
				do_limit: {},
				time_ctl: {},
				rinse_set: {},
				dialogConfig: false,
				TimeConfig: {
					on_time: "",
					off_time: ""
				},
				LimitConfig: {
					high_limit: "",
					up_limit: "",
					down_limit: ""
				},
				RinseConfig: {
					rinse_period: ""
				},
				rules: {
					on_time: [{
							validator: checkNum,
							trigger: 'blur'
						},
						{
							validator: checkOnOff,
							trigger: 'blur'
						},
						{
							required: true,
							message: '请输入开启时间',
							trigger: 'blur'
						}
					],
					off_time: [{
							validator: checkNum,
							trigger: 'blur'
						},
						{
							validator: checkOnOff,
							trigger: 'blur'
						},
						{
							required: true,
							message: '请输入关闭时间',
							trigger: 'blur'
						}
					],
					high_limit: [{
							validator: checkNum,
							trigger: 'blur'
						},
						{
							validator: checkHight,
							trigger: 'blur'
						},
						{
							required: true,
							message: '请输入高限',
							trigger: 'blur'
						}
					],
					up_limit: [{
							validator: checkNum,
							trigger: 'blur'
						},
						{
							validator: checkUp,
							trigger: 'blur'
						},
						{
							required: true,
							message: '请输入上限',
							trigger: 'blur'
						}
					],
					down_limit: [{
							validator: checkNum,
							trigger: 'blur'
						},
						{
							validator: min,
							trigger: 'blur'
						},
						{
							validator: checkDown,
							trigger: 'blur'
						},
						{
							required: true,
							message: '请输入下限',
							trigger: 'blur'
						}
					],
					rinse_period: [{
							validator: checkNum,
							trigger: 'blur'
						},
						{
							validator: checkRinse,
							trigger: 'blur'
						},
						{
							required: true,
							message: '请输入清洗周期',
							trigger: 'blur'
						}
					]
				},
				props: {
					checkStrictly: true,
					value: 'id',
					label: 'name',
					children: 'children',
					lazy: true,
					lazyLoad(node, resolve) {
						let val = node.path;
						_this.loadadr(val)
							.then((adr) => {
								resolve(adr);
							});
					}
				},
				fields: [{
						name: 'name',
						label: '名称',
						type: 'string',
						rule: [{
							required: true,
							message: '请输入名称',
							trigger: 'blur'
						}],
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					},
					{
						name: 'doDevicesIdAll',
						label: '溶氧设备',
						type: 'choose',
						selection: {
							prop: {
								label: 'alias',
								value: 'id'
							},
							data: (value) => {
								return this.api.Tactics.doAeratorDevices({
										doAeratorDevicesType: 1
									})
									.then((response) => {
										if (response.data.code == 1) {
											if (value != null) {
												value.selectdata = response.data.data.list;
											}
										}
										return response;
									})
							}
						},
						rule: [{
							required: true,
							message: '请选择溶氧设备',
							trigger: 'blur'
						}],
						limits: {
							look: false,
							add: true,
							edit: true,
							table: false,
							phone: true
						}
					},
					{
						name: 'devicesName',
						label: '溶氧设备',
						type: 'string',
						limits: {
							look: true,
							add: false,
							edit: false,
							table: true,
							phone: true
						}
					},
					{
						name: 'tacticsType',
						label: '策略类型',
						type: 'select', // string num image images text texts address select selects date latlong switch file
						selection: {
							prop: {
								label: 'label',
								value: 'value'
							},
							data: [{
									label: "小于",
									value: 1
								},
								{
									label: "大于",
									value: 2
								},
								{
									label: "等于",
									value: 3
								},
								{
									label: "其中某个值低于",
									value: 4
								},
								{
									label: "其中某个值高于",
									value: 5
								},
								{
									label: "平均值低于",
									value: 6
								},
								{
									label: "平均值高于",
									value: 7
								}
							]
						},
						rule: [{
							required: true,
							message: '请选择策略类型',
							trigger: 'blur'
						}],
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					},
					{
						name: 'tacticsValue',
						label: '策略值',
						type: 'num',
						rule: [{
								required: true,
								message: '请输入策略值',
								trigger: 'blur'
							},
							{
								validator: min,
								trigger: 'blur'
							}
						],
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					},
					{
						name: 'unit',
						label: '单位',
						type: 'string',
						limits: {
							look: true,
							add: false,
							edit: false,
							table: true,
							phone: true
						}
					},
					{
						name: 'executeType',
						label: '执行类型',
						type: 'select',
						selection: {
							prop: {
								label: 'label',
								value: 'value'
							},
							data: [{
									label: "开启增氧机",
									value: 1
								},
								{
									label: "关闭增氧机",
									value: 2
								},
								{
									label: "发短信报警",
									value: 3
								},
								{
									label: "打电话报警",
									value: 4
								},
								{
									label: "无操作",
									value: 5
								}
							]
						},
						rule: [{
							required: true,
							message: '请选择执行类型',
							trigger: 'blur'
						}],
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					},
					{
						name: 'aeratorDevicesIdAll',
						label: '增氧设备',
						type: 'choose',
						selection: {
							prop: {
								label: 'alias',
								value: 'id'
							},
							data: (value) => {
								return this.api.Tactics.doAeratorDevices({
										doAeratorDevicesType: 2
									})
									.then((response) => {
										if (response.data.code == 1) {
											if (value != null) {
												value.selectdata = response.data.data.list;
											}
										}
										return response;
									})
							}
						},
						limits: {
							look: false,
							add: true,
							edit: true,
							table: false,
							phone: true
						}
					},
					{
						name: 'aeratorDevicesName',
						label: '增氧设备',
						type: 'string',
						limits: {
							look: true,
							add: false,
							edit: false,
							table: true,
							phone: true
						}
					},
					{
						name: 'description',
						label: '描述',
						type: 'text',
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					}
				],
				limits: {
					add: true,
					delete: true,
					edit: false,
					find: true,
					export: false,
					look: false
				}
			};
		},
		methods: {
			SaveTerminal() {
				let formName = this.type == 1 ? "formAdd" : "AddRFID";
				if (this.type == 1) {
					this.$refs[formName].validate((valid) => {
						if (valid) {
							this.$store.commit('formload', true);
							let value = {
								qaedas_id: this.getCookie(this.config.jdid),
								name: this.formAdd.name,
								unique: this.formAdd.tag,
								image: this.formAdd.image,
								address: this.adrtrans(this.formAdd.address)
							};
							this.addterminal(value)
								.then((response) => {
									if (response.data.code == 1) {
										this.dialogAddVisible = false;
									}
									this.$store.commit('formload', false);
								});
						}
					});
				} else {
					this.$refs[formName].validate((valid) => {
						if (valid) {
							this.$store.commit('formload', true);
							this.AddRFID.qaedaId = this.getCookie(this.config.jdid);
							this.api.Terminal.add(this.AddRFID)
								.then((response) => {
									if (response.data.code == 1) {
										this.dialogAddVisible = false;
										this.load();
									}
									this.$store.commit('formload', false);
								});
						}
					});
				}
			},
			clearData(item) {
				this.$confirm('是否清除终端信息？', '警告', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					})
					.then(() => {
						this.api.Terminal.deletedata({
							id: item.id
						});
					})
			},
			EditTerminal() {
				let formName = this.type == 1 ? "formEdit" : "EditRFID";
				if (this.type == 1) {
					this.$refs[formName].validate((valid) => {
						if (valid) {
							let value = {
								id: this.formEdit.id,
								name: this.formEdit.name,
								image: this.formEdit.image,
								address: this.adrtrans(this.formEdit.address)
							};
							this.$store.commit('formload', true);
							this.editterminal(value)
								.then((response) => {
									if (response.data.code == 1) {
										this.dialogEditVisible = false;
									}
									this.$store.commit('formload', false);
								});
						}
					});
				} else {
					this.$refs[formName].validate((valid) => {
						if (valid) {
							this.$store.commit('formload', true);
							let value = {
								id: this.EditRFID.id,
								name: this.EditRFID.name,
								image: this.EditRFID.image,
								address: this.EditRFID.address,
								description: this.EditRFID.description
							}
							this.api.Terminal.update(value)
								.then((response) => {
									if (response.data.code == 1) {
										this.dialogEditVisible = false;
									}
									this.$store.commit('formload', false);
								});
						}
					});
				}
			},
			EditOpenTerminal(item) {
				this.dialogEditVisible = true;
				item.rfTerminalType == 2 ? this.type = 2 : this.type = 1;
				this.$nextTick(() => {
					if (item.rfTerminalType == 2) {
						this.$refs['EditRFID'].resetFields();
						this.EditRFID.id = item.id;
						this.EditRFID.name = item.name;
						this.EditRFID.address = item.city;
						this.EditRFID.description = item.description;
						this.EditRFID.image = item.image;
						this.EditRFID.devicesNo = item.devicesNo;
					} else {
						this.$refs['formEdit'].resetFields();
						this.formEdit.id = item.id;
						this.formEdit.name = item.name;
						this.formEdit.image = item.image;
						this.formEdit.tag = item.unique;
					}
				})
			},
			AddOpenTerminal() {
				this.dialogAddVisible = true;
				this.type = 1;
				this.$nextTick(() => {
					this.$refs['formAdd'].resetFields();
				})
			},
			AddhandleAvatarSuccess(res, file) {
				this.formAdd.image = res.data.url;
			},
			AddbeforeAvatarUpload(file) {
				const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
				const isLt2M = file.size / 1024 / 1024 < 2;
				if (!isJPG) {
					this.$message.error('上传头像图片只能是 JPG 或 png 格式!');
				}
				if (!isLt2M) {
					this.$message.error('上传头像图片大小不能超过 2MB!');
				}
				return isJPG && isLt2M;
			},
			EdithandleAvatarSuccess(res, file) {
				this.formEdit.image = res.data.url;
			},
			EditbeforeAvatarUpload(file) {
				const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
				const isLt2M = file.size / 1024 / 1024 < 2;
				if (!isJPG) {
					this.$message.error('上传头像图片只能是 JPG 格式!');
				}
				if (!isLt2M) {
					this.$message.error('上传头像图片大小不能超过 2MB!');
				}
				return isJPG && isLt2M;
			},
			moveto(item) {
				if (item.rfTerminalType == 2) {
					this.$router.push({
						path: '/iot/RFIDData',
						query: {
							id: item.id
						}
					});
				} else if (item.isDisinfection == 1) {
					this.$router.push({
						path: '/iot/Disinfection',
						query: {
							id: item.id
						}
					});
				} else if (item.isSample == 1) {
					this.$router.push({
						path: '/iot/Sample',
						query: {
							id: item.id
						}
					});
				} else {
					this.$router.push({
						path: '/iot/sensor',
						query: {
							id: item.id,
							type: item.terminalType,
							name: item.name
						}
					});
				}
			},
			load() {
				this.getRFIDList();
			},
			convert(num) {
				var mynum = 0;
				if (num > 10000) {
					mynum = num / 10000;
					return mynum.toFixed(1) + "万";
				} else {
					return num;
				}
			},
			getRFIDList() {
				this.api.Terminal.getList({
						qaedaId: this.getCookie(this.config.jdid)
					})
					.then((res) => {
						this.RFIDData = res.data.data.list;
					})
			},
			openInfo(item) {
				this.Info = {};
				this.Info.name = item.name;
				this.api.Devicesinfo.read({
						unique: item.unique
					})
					.then(res => {
						let info = res.data.data;
						if (res.data.code == 1) {
							this.dialogInfo = true;
							this.Info.hw_version = info.hw_version;
							this.Info.sw_version = info.sw_version;
							this.Info.IMEI = info.IMEI;
							this.Info.CCID = info.CCID;
							this.Info.serial = info.serial;
						}
					})
			},
			OpenIco(item) {
				this.dialogIco = true;
				this.icoName = item.name;
				this.$nextTick(() => {
					let size = 300,
						imgsize = 60,
						url = this.config.icourl + item.id,
						imgurl = require("./../../../assets/ynkj.png");
					let backsize = imgsize * 1.3,
						imgxy = (size - imgsize) / 2,
						backxy = (size - backsize) / 2;
					let canvas = document.getElementById('ico');
					new qrious({
						element: canvas,
						size: size,
						level: 'H',
						value: url
					});
					let draw = canvas.getContext('2d');
					draw.fillStyle = '#FFF';
					draw.fillRect(backxy, backxy, backsize, backsize);
					let img = new Image();
					img.src = imgurl;
					img.onload = function() {
						draw.drawImage(img, imgxy, imgxy, imgsize, imgsize);
					}
				})
			},
			saveIco() {
				let canvas = document.getElementById('ico');
				let url = canvas.toDataURL("image/png");
				var oA = document.createElement("a");
				oA.download = this.icoName;
				oA.href = url;
				document.body.appendChild(oA);
				oA.click();
				oA.remove();
			},
			OpenDevice(item) {
				this.dialogDevice = true;
				this.terminalData = item;
				this.deviceType = "do_limit";
				this.getConfig();
			},
			handleDevice(tab, event) {
				this.deviceType = tab.name;
				this.getConfig();
			},
			getConfig() {
				this[this.deviceType] = [];
				this.api.preferences.getList({
						m_terminal_id: this.terminalData.id,
						configType: this.deviceType
					})
					.then(res => {
						if (res.data.code === 1) {
							let data = res.data.data.list,
								returnData = {},
								NOs = [];
							for (let item of data) {
								if (!returnData[item.channelNo + "," + item.no]) {
									returnData[item.channelNo + "," + item.no] = [];
									NOs.push(item.channelNo + "," + item.no);
								}
								returnData[item.channelNo + "," + item.no].push(item);
							}
							this[this.deviceType] = returnData;
							this.NOs = NOs;
						}
					})
			},
			OpenConfig(num) {
				const forms = {
					do_limit: "LimitConfig",
					time_ctl: "TimeConfig",
					rinse_set: "RinseConfig"
				}
				let type = this.deviceType,
					config = {},
					no = num.split(",")[1],
					channelNo = num.split(",")[0];
				console.log(this[type][num])
				if (this[type][num][0] && this[type][num][0].devicesConfigInfo && this[type][num][0].devicesConfigInfo[0]) {
					config = this[type][num][0].devicesConfigInfo[0];
				}
				this.dialogConfig = true;
				this.$nextTick(() => {
					this.$refs[forms[type]].resetFields();
					this[forms[type]].no = no;
					this[forms[type]].configType = type;
					this[forms[type]].channelNo = channelNo;
					this.LimitConfig.high_limit = config.high_limit;
					this.LimitConfig.up_limit = config.up_limit;
					this.LimitConfig.down_limit = config.down_limit;
					this.TimeConfig.on_time = config.on_time;
					this.TimeConfig.off_time = config.off_time;
					this.RinseConfig.rinse_period = config.rinse_period;
				})
			},
			SaveConfig() {
				const forms = {
					do_limit: "LimitConfig",
					time_ctl: "TimeConfig",
					rinse_set: "RinseConfig"
				}
				let type = this.deviceType;
				this.$refs[forms[type]].validate((valid) => {
					if (valid) {
						this[forms[type]].m_terminal_id = this.terminalData.id;
						this.api.preferences.add(this[forms[type]])
							.then(res => {
								if (res.data.code === 1) {
									this.dialogConfig = false;
									this.getConfig();
								}
							})
					}
				});
			}
		},
		mounted: function() {
			_this = this;
			this.load();
			this.mytime = setInterval(this.getRFIDList, 2000);
		},
		beforeDestroy: function() {
			clearInterval(this.mytime);
		},
		computed: {
			isHistory() {
				for (let key in this.$store.state.Iot.terminal) {
					if (this.$store.state.Iot.terminal[key].agoTerminal == 2) {
						return true;
					}
				}
			}
		}
	}
</script>

<style scoped>
	p {
		margin: 0;
	}

	.el-upload {
		display: inline-block;
		text-align: center;
		cursor: pointer;
		outline: 0;
		border: 1px grey dashed !important;
		border-radius: 5% !important;
	}

	.ljs-diqu {
		font-size: 16px;
		font-weight: 600;
		text-align: center;
		border-top: 1px solid rgb(91, 155, 213);
		padding: 4px;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}

	.bottom-address {
		position: relative;
	}

	.address-text {
		font-size: 16px;
		font-weight: 600;
		text-align: center;
		border-top: 1px solid rgb(91, 155, 213);
		padding: 4px;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		padding: 4px 20px;
	}

	.address-ico {
		position: absolute;
		right: 0;
		top: 0;
		font-size: 18px;
		line-height: 30px;
	}

	.address-config {
		position: absolute;
		left: 0;
		top: 0.5px;
		font-size: 20px;
		line-height: 30px;
	}

	.ljs-zi2 {
		font-size: 15px;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}

	.dis-inbl {
		line-height: 28px;
		text-align: right;
		position: relative;
		top: 10px;
	}

	.tex-ri {
		line-height: 28px;
		text-align: left;
		position: relative;
		top: 10px;
	}

	.ljs-body {
		height: 117px;
		padding: 6px 0px 6px 6px;
	}

	.ljs-beijing {
		text-align: center;
	}

	.ljs-beijing img {
		width: 100px;
		height: 100px;
		border-radius: 50%;
		box-shadow: darkgrey 0px 0px 8px 1px inset;
	}

	.bg-purple {
		/* background: #d3dce6; */
		width: 240px;
		/* border-radius: 4px;
		min-height: 36px;
		height: 180px;
		margin-right: 20px;
		margin-bottom: 20px;
		border: 1px solid #d3dce6;
		background-color: white; */
		margin-top: 10px;
		float: left;
		margin-right: 10px;
	}

	.dibu {
		margin-bottom: 1rem;
	}

	.neirong {
		margin-bottom: 20px;
		text-align: left;
	}

	.tup1 {
		width: 8rem;
		height: 8rem;
		margin: auto;
	}

	.zi2 {
		float: right;
		padding: 3px 0;
		color: #555;
		margin-right: 0.9375rem;
	}

	.zi1 {
		color: #555;
		max-width: 6em;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		float: left;
		padding-left: 10px;
	}

	.card3 {
		padding-top: 6px;
	}

	.card2 {
		background-color: #9faec5;
		height: 2rem;
		/* border-bottom: 0.0625rem solid #EBEEF5; */
		text-align: center;
		/* border-radius: 4px 4px 0 0; */
	}

	.card1 {
		width: 16rem;
		text-align: center;
		margin-top: 1.25rem;
		float: left;
		margin-left: 1.25rem;
	}

	.kuan {
		width: 100%;
	}

	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 178px;
		line-height: 178px;
		text-align: center;
	}

	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}

	.border {
		border: 1px solid #dcdfe6;
		border-radius: 4px;
	}

	.padding {
		padding-top: 16px;
	}

	.title {
		text-align: center;
		margin-top: -10px;
	}

	.top {
		margin-top: 10px;
	}

	.none {
		margin-top: 80px;
		margin-bottom: 80px;
		text-align: center;
		font-size: 80px;
		font-family: "STCaiyun";
		color: #1991FA;
	}

	.lixian {
		float: right;
		color: gray;
		margin-right: 0.9375rem;
	}

	.zaixian {
		float: right;
		color: green;
		margin-right: 0.9375rem;
	}

	.config-device-box {
		display: flex;
		justify-content: space-between;
		margin: 10px 0;
		width: 100%;
	}

	.config-device-box-title {
		font-size: 17px;
	}

	.config-device-box-set {
		font-size: 16px;
		color: blue;
		cursor: pointer;
		margin-right: 10px;
	}

	.config-device-box-name {
		margin: 5px;
	}

	.config-title {
		font-size: 20px;
		font-weight: 800;
		margin-bottom: 15px;
	}

	.dialog-footer {
		text-align: center;
	}

	.bread {
		height: 14px;
		padding: 8px 0;
	}

	.content {
		display: flex;
		margin-top: 10px;
	}

	.content-item {
		width: 100%;
		margin: 5px;
		background-color: #9faec5;
		color: white;
		text-align: center;
		padding: 3px;
		border-radius: 5px;
	}

	.content-content {
		font-size: 18px;
		margin-top: 10px;
	}

	.content-title {
		font-size: 12px;
		margin-top: 10px;
		margin-bottom: 10px;
	}

	.info-title {
		font-size: 18px;
		color: #303133;
		line-height: 35px;
		text-align: right;
	}

	.info-content {
		font-size: 18px;
		color: #606266;
		line-height: 35px;
	}

	.ico-downLoad {
		text-align: right;
	}

	.ico-downLoad span {
		color: blue;
		cursor: pointer;
	}

	@media screen and (min-width: 0px) and (max-width: 700px) {
		.bg-purple {
			width: 100%;
			float: none;
		}

		.bread {
			padding-left: 5px;
		}

		.top {
			margin-left: 5px;
		}

		.card-w {
			padding: 0 5px;
			padding-top: 5px;
		}
	}
</style>

<style>
	.info .el-dialog .el-dialog__header {
		background-color: #18bc9c;
	}

	.info .el-dialog .el-dialog__header .el-dialog__title {
		font-weight: 900;
	}

	.info .el-dialog .el-dialog__header .el-dialog__headerbtn .el-dialog__close {
		color: #000;
	}

	.el-divider__text {
		background-color: #f0f0f0 !important;
	}
</style>
